<template>
  <div>
    <a-row :gutter="[8, 8]" style="margin: 0;">
      <a-col :span="24" style="text-align: right; margin-top: 10px;">
        <a-button type="primary" icon="edit" @click="visibleEditShift = true"
          >Update Main Shift</a-button
        >
      </a-col>
      <!-- <a-col :sm="3" :md="3">
        <a-card class="card-6" style="border: 0;">
          <AvatarEmployee />
        </a-card>
      </a-col> -->
      <a-col :sm="21" :md="12">
        <a-card size="small">
          <InfoEmployee
            :employee="detailEmployee"
            :loadingItem="loadingTable"
            :updateEmployeeOnView="updateEmployeeOnView"
          />
        </a-card>
        <br />
        <DisplayDetailUser
          v-if="detailEmployee.user"
          :user="detailEmployee.user"
          :visibleUpdate="toggleUpdateUserDrawer"
        />
      </a-col>
      <a-col :sm="24" :md="12">
        <a-card size="small">
          <DetailLeaveDay
            :refreshEmployeeAfterLeaveAnualUpdated="
              refreshEmployeeAfterLeaveAnualUpdated
            "
            :employee="detailEmployee"
          />
        </a-card>
        <br />
        <a-card size="small">
          <AnnualLeaveDayList v-if="!loadingTable" :employee="detailEmployee" />
        </a-card>
      </a-col>
    </a-row>

    <a-drawer
      :width="450"
      title="Chỉnh sửa thông tin nhân viên"
      placement="right"
      :visible="visibleUpdateUser"
      @close="() => (visibleUpdateUser = false)"
      :bodyStyle="{ overflowY: 'auto', maxHeight: 'calc(100% - 100px)' }"
    >
      <UpdateUser
        :updateEmployeeOnView="updateEmployeeOnView"
        :closeDrawerUpdateEmployee="() => (visibleUpdateUser = false)"
        :formEmployee="detailEmployee.user"
        :loadingItem="loadingTable"
      />
    </a-drawer>

    <a-modal
      v-model="visibleEditShift"
      title="Update main shift"
      :footer="null"
    >
      <UpdateMainShift
        :employee="detailEmployee"
        :close="
          () => {
            visibleEditShift = false;
          }
        "
        :updateEmployeeOnView="updateEmployeeOnView"
        :refreshEmployeeAfterLeaveAnualUpdated="
          refreshEmployeeAfterLeaveAnualUpdated
        "
      />
    </a-modal>
  </div>
</template>
<script>
import InfoEmployee from "./detailEmployee/infoEmployee";
import moment from "moment";
import getQuery from "../data/getData";
import DetailLeaveDay from "./leaveDay/detailLeaveDay";
import AnnualLeaveDayList from "./annualLeaveYear/AnnualLeaveYearList";
import DisplayDetailUser from "@/views/configAdmin/user/components/detailUser/displayDetailUser";
import UpdateUser from "@/views/configAdmin/user/components/detailUser/updateUser";
import UpdateMainShift from "./detailEmployee/updateMainShift.vue";

export default {
  components: {
    InfoEmployee,
    DetailLeaveDay,
    AnnualLeaveDayList,
    DisplayDetailUser,
    UpdateUser,
    UpdateMainShift,
  },
  watch: {
    $route(to, from) {
      const toId = to.params?.idEmployee;
      const fromId = from.params?.idEmployee;
      if (toId !== fromId) {
        this.getEmployee();
      }
    },
  },
  data() {
    return {
      loadingTable: true,
      loadingUpdate: false,
      loadingDelete: false,
      detailEmployee: {},
      visibleUpdateUser: false,
      visibleEditShift: false,
    };
  },
  methods: {
    showDrawerUpdateEmployee() {
      this.visibleUpdateEmployee = true;
    },
    moment,
    getEmployee() {
      this.loadingTable = true;
      this.$apollo
        .query({
          query: getQuery.queryGetUpdateEmployee,
          variables: {
            id: this.$route.params.idEmployee,
          },
        })
        .then(({ data }) => {
          if (data?.getEmployee) {
            this.detailEmployee = { ...data.getEmployee };
          }
          this.loadingTable = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          console.log("Không lấy được chi tiết nhân viên", error);
        });
    },
    updateEmployeeOnView(employee) {
      this.detailEmployee = { ...this.detailEmployee, ...employee };
    },
    refreshEmployeeAfterLeaveAnualUpdated(annualLeaveDay) {
      this.detailEmployee = { ...this.detailEmployee, annualLeaveDay };
    },
    refreshEmployeeAfterSickDayUpdated(sickLeaveDay) {
      this.detailEmployee = { ...this.detailEmployee, sickLeaveDay };
    },

    /**
     * Toggle drawer update User on view
     * @param value {boolean}
     */
    toggleUpdateUserDrawer(value) {
      this.visibleUpdateUser = value;
    },
  },
  created() {
    this.getEmployee();
  },
};
</script>
<style scoped>
.ant-form-item {
  margin-bottom: 0px;
}
.card-6 >>> .ant-card-body {
  padding: 6px !important;
  padding-top: 24px !important;
}
</style>
